import React, { useEffect, useState } from "react";
import { Grid } from "grommet";
import { useSelector } from "react-redux";
import { CustomCard } from "../competetive/CustomCard";
import { storageAdminService } from "../../services";

export const ApplicationPrimariesGrid = ({ productsList, primaryId, history, size, applicationId, ...rest }) => {
    const user = useSelector((state) => {
        return state.session.user;
    });
    const session = useSelector((state) => {
        return state.session;
    });
    const [isUserApplicationAdmin, setIsUserApplicationAdmin] = useState(false)
    useEffect(() => {
        storageAdminService.isUserInAdminGroup(session.user.access, applicationId).then((response) => {
            if (response.is_member) {
                setIsUserApplicationAdmin(response.is_member)
            }
            else {
                setIsUserApplicationAdmin(false)
            }
        })
    }, [applicationId, session])


    const products = useSelector(() => {
        productsList.sort((a, b) => (a.order > b.order) ? 1 : -1);
        return productsList.map((group, index) => {
            const productsDet = {
                id: group.id,
                name: group.primary_name,
                description: group.primary_description,
                page_link: `/storage/${primaryId}/secondary/${group.id}`,
            };
            return (
                <CustomCard
                    key={productsDet.id}
                    title={productsDet.name}
                    description={productsDet.description}
                    onClickHandler={() => {
                        history.push(productsDet.page_link);
                    }}
                />
            );
        });
    });

    return (
        <Grid
            columns={"20%"} gap={"medium"}
            rows={[["auto", "full"]]}
            {...rest}
            pad='medium'
            fill
        >
            {products}
            {user.user && user.user.user_role && user.user.user_role.role_name && user.user.user_role.role_name.toString().startsWith('Admin') && isUserApplicationAdmin &&
                <>
                    <CustomCard title={"Admin"} description={"Customize your application"} onClickHandler={() => {
                        history.push(`/storage-admin-dash/${applicationId}`)
                    }} />
                </>}
        </Grid>
    );
};